import React, { lazy } from 'react';
import GuestGuard from '../guards/GuestGuard';
import Loadable from "./loadable";

// Authentication
const Login = Loadable(lazy(() => import('../pages/auth/Login')));
const Register = Loadable(lazy(() => import('../pages/auth/Register')));
const ResetPassword = Loadable(lazy(() => import('../pages/auth/ResetPassword')));
const ResetPasswordConfirm = Loadable(lazy(() => import('../pages/auth/ResetPasswordConfirm')));
const Impersonate = Loadable(lazy(() => import('../pages/auth/Impersonate')));
// const VerifyCode = Loadable(lazy(() => import('../pages/auth/VerifyCode')));

// SSO
const SsoDenied = Loadable(lazy(() => import('../pages/auth/sso/SsoDenied')));
const SsoAccountDisabled = Loadable(lazy(() => import('../pages/auth/sso/SsoAccountDisabled')));
const SsoCallback = Loadable(lazy(() => import('../pages/auth/sso/SsoCallback')));

const AuthRoutes = [
    {
        path: 'auth',
        children: [
            {
                path: 'login',
                element: (
                    <GuestGuard>
                        <Login />
                    </GuestGuard>
                ),
            },
            {
                path: 'register',
                element: (
                    <GuestGuard>
                        <Register />
                    </GuestGuard>
                ),
            },
            {
                path: 'register',
                element: (
                    <GuestGuard>
                        <Register />
                    </GuestGuard>
                ),
            },
            { path: 'login-unprotected', element: <Login /> },
            { path: 'register-unprotected', element: <Register /> },
            { path: 'impersonate', element: <Impersonate /> },
            { path: 'reset-password', element: <ResetPassword /> },
            { path: 'verify', element: <ResetPasswordConfirm /> },
            {
                path: 'sso/denied',
                element: (
                    <GuestGuard>
                        <SsoDenied />
                    </GuestGuard>
                ),
            },
            {
                // BIZH-1194 — account-disabled page
                path: 'sso/disabled',
                element: (
                    <GuestGuard>
                        <SsoAccountDisabled />
                    </GuestGuard>
                ),
            },
            {
                // BIZH-1191 — SSO handoff exchange + JWTContext hydration
                path: 'sso/callback',
                element: (
                    <GuestGuard>
                        <SsoCallback />
                    </GuestGuard>
                ),
            },
        ],
    },
];

export default AuthRoutes;
